module.exports = __webpack_public_path__ + "media/images/sp/accessories/men/men_01_thumb-041f15e0cae7fd174ec6ed7d893982bc.jpg";